import React from "react";

import "./LoadingIndicator.css";

const LoadingIndicator = ({ width = 20, height = 20 }) => (
  <div className="loader" style={{ width, height }}></div>
);

export default LoadingIndicator;
